import { useTranslation } from "react-i18next";
import { DatePickerInput } from "@/components/ui/DatePickerInput";
import type { Fields } from ".";
import type { FormikProps } from "formik";

interface IProps {
  label?: string;
  formik: FormikProps<Fields>;
  fieldName: keyof Fields;
}

export function StartEndDateField({ formik, fieldName, label }: IProps) {
  const { t } = useTranslation(["projects", "common"]);
  const value = formik.values[fieldName];
  const selectedDate = value instanceof Date ? value : undefined;

  const isEndDateField = fieldName === "endDate";
  const startDateValue = formik.values.startDate;

  const minDate = isEndDateField
    ? startDateValue instanceof Date
      ? startDateValue
      : undefined
    : undefined;

  const hasError = Boolean(
    formik.touched[fieldName] && formik.errors[fieldName],
  );

  return (
    <DatePickerInput
      id={fieldName}
      name={fieldName}
      label={label ?? t("common:labels.date")}
      value={selectedDate}
      minDate={minDate}
      onChange={(date) => formik.setFieldValue(fieldName, date ?? null)}
      error={hasError ? (formik.errors[fieldName] as string) : undefined}
    />
  );
}
